import { render, staticRenderFns } from "./sendmsg.vue?vue&type=template&id=3b96b48b&"
import script from "./sendmsg.vue?vue&type=script&lang=js&"
export * from "./sendmsg.vue?vue&type=script&lang=js&"
import style0 from "./sendmsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports